import {InstantReportRunResult, ReportChartData, FilterState, FilterWidgetValueParams, ReportTypeData, ReportState} from "../../lib/report-builder"

import {CommandCaller} from "../../lib/commands"
import {dateToYYYYMMDD} from "../../lib/utils"
import {Axis, DisplayModes} from "../../lib/report-builder/graph-renderer";
import {ReportStoreOwnProps} from "../../lib/report-builder/lib";

export type StatusDataCallJs  = {
	serial: string|number,
	title: string,
	color: string,
	isCustom: boolean,
	isDeleted: boolean
}

export type GeographicStateDataCallJs = {
	serial: string|number,
	state: string,
	stateShort: string
}

export type TypeDataCallJs = {
	category: number,
	serial: string|number,
	target: "individual"|"organisational",
	title: string,
	urlTitle: string
}

export type CallJsParams = {
	states: GeographicStateDataCallJs[],
	ajaxPageUrl: string,
	statuses: StatusDataCallJs[],
	types: TypeDataCallJs[]
}

export type MembershipReportAxes = {types: Axis}

export type MembershipReportFilterTypes = "date range"|"timeframe"|"types"|"states"|"status"
export type MembershipReportFilters = {[k in MembershipReportFilterTypes]: FilterWidgetValueParams}

export type MembershipReportTypes = "current"|"numtypes"|"statetype"
export type MembershipReportData = {[k in MembershipReportTypes]: ReportTypeData<MembershipReportAxes, MembershipReportFilters, DisplayModes>}

export type MembershipReportState = ReportState<MembershipReportAxes, MembershipReportFilters, DisplayModes, MembershipReportData>
export type MembershipReportOwnProps = ReportStoreOwnProps<MembershipReportAxes, MembershipReportFilters, DisplayModes, MembershipReportData, MembershipReportState>

export const runCurrentReport = async (status: FilterState, ajaxPageUrl: string) => {
	const statusSerials = status.type == "checkbox" ? status.checked : []
	const params: InstantReportRunParams = {
		statusSerials: statusSerials.length ? statusSerials : undefined,
	}
	return await new CommandCaller(ajaxPageUrl).runGet('count memberships per type by statustype',
		params) as InstantReportRunResult
}

export const runReport = async (status: FilterState, statesFilter: FilterState, typeFilter: FilterState, reportType: "statetype"|"numtypes", fromDate: Date, toDate: Date, period: string, ajaxPageUrl: string) => {
	const statusSerials = status.type == "checkbox" ? status.checked : []
	const states = statesFilter.type == "checkbox" ? statesFilter.checked : []
	const typeSerials = reportType == "statetype" && typeFilter.type == "checkbox" ? typeFilter.checked : []
	const params: ReportRunParams = {
		startDate: dateToYYYYMMDD(fromDate),
		endDate: dateToYYYYMMDD(toDate),
		period: isPeriod(period) ? period : "auto",
		states: states && states.length ? states : undefined,
		typeSerials: typeSerials && typeSerials.length ? typeSerials : undefined,
		statusSerials: statusSerials.length ? statusSerials : undefined,
	}
	return await new CommandCaller(ajaxPageUrl).runGet('count memberships per period and type by statustype and state',
		params) as ReportRunResult
}

type ReportRunParams = {
	startDate: string,
	endDate: string,
	period: Period,
	statusSerials: undefined|string[],
	states: undefined|string[],
	typeSerials: undefined|string[]
}

type InstantReportRunParams = {
	statusSerials: undefined|string[],
}

type ReportRunResult = {
	params: ReportRunParams
	data: ReportChartData
}

type Period = "auto"|"year"|"month"|"day"
const isPeriod = (s: string): s is Period => s == "auto" || s=="year" || s=="month" || s=="day"



// WEBPACK FOOTER //
// ./src/membership3/membership-reports/report1.ts